module.exports = __webpack_public_path__ + "pallets.png?9369f7878ccd7bced317ba8aa0c3cac0";